(() => {
  if (window.shinigamiPdpInitialized) return;
  window.shinigamiPdpInitialized = true;

  const barObservers = new WeakMap();
  let scheduled = false;

  const getProductRoot = () => document.querySelector('product-info[id^="MainProduct-"]');
  const getPurchasePanel = (root) => root?.querySelector('[id^="ProductInfo-"]');

  const getSelectionText = (panel) => {
    const selected = [];

    panel.querySelectorAll('variant-selects fieldset').forEach((fieldset) => {
      const label = fieldset.querySelector('legend')?.textContent?.replace(':', '').trim();
      const input = fieldset.querySelector('input:checked');
      if (label && input?.value) selected.push(`${label}: ${input.value}`);
    });

    panel.querySelectorAll('variant-selects select').forEach((select) => {
      const label = panel.querySelector(`label[for="${select.id}"]`)?.textContent?.trim();
      const value = select.options[select.selectedIndex]?.textContent?.trim();
      if (label && value) selected.push(`${label}: ${value}`);
    });

    return selected.join(' / ');
  };

  const syncBar = (bar) => {
    const root = bar.closest('product-info') || getProductRoot();
    const panel = getPurchasePanel(root);
    if (!panel) return;

    const primaryButton = panel.querySelector('.product-form__submit');
    const sourcePrice = panel.querySelector('[id^="price-"] .price');
    const stickyButton = bar.querySelector('[data-shini-sticky-add]');
    const stickyPrice = bar.querySelector('[data-shini-sticky-price]');
    const stickySelection = bar.querySelector('[data-shini-sticky-selection]');

    const nextPrice = sourcePrice?.outerHTML;
    const nextSelection = getSelectionText(panel);
    if (nextPrice && stickyPrice && stickyPrice.innerHTML !== nextPrice) stickyPrice.innerHTML = nextPrice;
    if (stickySelection && stickySelection.textContent !== nextSelection) stickySelection.textContent = nextSelection;

    if (stickyButton && primaryButton) {
      stickyButton.disabled = primaryButton.disabled;
      const nextButtonLabel = primaryButton.textContent.trim() || 'Add to cart';
      if (stickyButton.textContent !== nextButtonLabel) stickyButton.textContent = nextButtonLabel;
    }
  };

  const initBar = (bar) => {
    if (bar.dataset.shiniInitialized === 'true') {
      syncBar(bar);
      return;
    }

    bar.dataset.shiniInitialized = 'true';
    bar.hidden = false;
    syncBar(bar);

    const root = bar.closest('product-info') || getProductRoot();
    const panel = getPurchasePanel(root);
    const primaryForm = panel?.querySelector('.product-form');

    if (primaryForm && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > 240),
        { threshold: 0.12 }
      );
      observer.observe(primaryForm);
      barObservers.set(bar, observer);
    }
  };

  const removePendingCopy = () => {
    document.querySelectorAll('[data-shini-pdp-details] p, [data-shini-pdp-details] li').forEach((element) => {
      if (element.textContent.toLowerCase().includes('coming soon')) element.remove();
    });
  };

  const enhancePurchasePanel = () => {
    const source = document.querySelector('[data-shini-pdp-enhancements]');
    const panel = getPurchasePanel(getProductRoot());
    if (!source || !panel) return;

    const price = panel.querySelector('[id^="price-"]');
    const introTemplate = source.querySelector('[data-shini-intro-template]');
    if (price && introTemplate && !panel.querySelector('.shini-pdp-intro')) {
      price.insertAdjacentElement('afterend', introTemplate.content.firstElementChild.cloneNode(true));
    }

    const variantPicker = panel.querySelector('variant-selects');
    const sizeGuideTemplate = source.querySelector('[data-shini-size-guide-template]');
    const hasSizeOption = [...(variantPicker?.querySelectorAll('fieldset legend, label') || [])].some((label) =>
      label.textContent.toLowerCase().includes('size')
    );
    if (variantPicker && sizeGuideTemplate && hasSizeOption && !panel.querySelector('.shini-pdp-fit-guide')) {
      variantPicker.insertAdjacentElement('afterend', sizeGuideTemplate.content.firstElementChild.cloneNode(true));
    }

    const productForm = panel.querySelector('.product-form');
    const reassuranceTemplate = source.querySelector('[data-shini-reassurance-template]');
    if (productForm && reassuranceTemplate && !panel.querySelector('.shini-pdp-reassurance')) {
      productForm.insertAdjacentElement('afterend', reassuranceTemplate.content.firstElementChild.cloneNode(true));
    }
  };

  const removeDuplicateSizeGuideLinks = () => {
    document.querySelectorAll('[data-shini-pdp-details] a').forEach((link) => {
      if (!/view\s+(the\s+)?(size|fit)|size\s+chart/i.test(link.textContent.trim())) return;

      const paragraph = link.closest('p');
      if (paragraph && paragraph.textContent.trim() === link.textContent.trim()) {
        paragraph.remove();
      } else {
        link.remove();
      }
    });
  };

  const refresh = () => {
    scheduled = false;
    enhancePurchasePanel();
    document.querySelectorAll('[data-shini-pdp-sticky]').forEach(initBar);
    removePendingCopy();
    removeDuplicateSizeGuideLinks();
  };

  const scheduleRefresh = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(refresh);
  };

  document.addEventListener('click', (event) => {
    const stickyButton = event.target.closest('[data-shini-sticky-add]');
    if (!stickyButton) return;

    const bar = stickyButton.closest('[data-shini-pdp-sticky]');
    const root = bar?.closest('product-info') || getProductRoot();
    const primaryButton = getPurchasePanel(root)?.querySelector('.product-form__submit');
    primaryButton?.click();
  });

  document.addEventListener('change', scheduleRefresh);
  document.addEventListener('product-info:loaded', scheduleRefresh);

  const observer = new MutationObserver(scheduleRefresh);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();
